<template>
    <div class="card">
        <div class="card-body">
            <div class="profile-title pe-2 ps-2">Profile</div>
            <div class="your-info pe-2 ps-2">Your Information</div>
            <div class="mt-2 p-2">
                <div>
                    <div class="driver-name">Driver name</div>
                    <div class="name-value">{{ driverInfo.first_name }}&nbsp;{{ driverInfo.middle_name }}&nbsp;{{ driverInfo.last_name }}</div>
                </div>
                <hr>
                <div class="d-flex justify-content-between">
                    <div class="driver-id">Driver ID</div>
                    <div class="terminal-number">Terminal number</div>
                </div>
                <div class="mt-1 d-flex justify-content-between">
                    <div class="id-value">{{ driverInfo.driver_id }}</div>
                    <div class="terminal-value">{{ driverInfo.terminal_number }}</div>
                </div>
                <hr>
                <div class="d-flex justify-content-between">
                    <div class="driver-id">Plate number</div>
                    <div class="terminal-number">ABN</div>
                </div>
                <div class="mt-1 d-flex justify-content-between">
                    <!-- 車牌輸入框或顯示 -->
                    <div class="id-value">
                      <template v-if="editingPlate">
                        <input v-model="newPlateNumber" class="form-input" placeholder="Enter new plate number" />
                      </template>
                      <template v-else>
                        {{ driverInfo.plate_number }}
                      </template>
                    </div>

                    <!-- ABN 輸入框或顯示 -->
                    <div class="terminal-value">
                      <template v-if="editingAbn">
                        <input v-model="newAbn" class="form-input" placeholder="Enter new ABN" />
                      </template>
                      <template v-else>
                        {{ driverInfo.abn }}
                      </template>
                    </div>
                </div>
                <!-- 編輯按鈕和確定/取消按鈕 -->
                <div class="mt-2 d-flex justify-content-between">
                    <template v-if="editingPlate">
                      <div class="button-group">
                        <button class="btn btn-primary" @click="savePlateNumber">OK</button>
                        <button class="btn btn-secondary" @click="cancelEditPlate">Cancel</button>
                      </div>
                    </template>
                    <template v-else>
                      <div class="edit-plate" @click="startEditPlate">Edit plate</div>
                    </template>

                    <template v-if="editingAbn">
                      <div class="button-group">
                        <button class="btn btn-primary" @click="saveAbn">OK</button>
                        <button class="btn btn-secondary" @click="cancelEditAbn">Cancel</button>
                      </div>
                    </template>
                    <template v-else>
                      <div class="edit-abn" @click="startEditAbn">Edit ABN</div>
                    </template>
                </div>
                <hr>
            </div>
            <div class="p-2">
              <div class="withdraw-title">
                Withdrawal bank account 
              </div>
              <div class="withdraw-title">
                / PayID details
              </div>
            </div>
            <div class="withdraw-subtitle p-2 mt-2">
              Select the account you wish to nominate for withdrawals. To edit or add details please contact customer support via SMS on <strong>0466 048009</strong> (Monday to Friday 10:30am to 5pm)
            </div>
            <div class="row mt-3 p-2 mb-5">
              <div
              v-for="(account, index) in driverInfo?.accounts"
              :key="account.id"
              class="row account-item mx-0 my-3 align-items-center"
              :class="{ 
                selected: selectedAccountId === account.id,
              }"
              @click="selectAccount(account.id)"
            >
              <!-- 第一欄：勾選框 (綠底勾選) -->
              <div class="col-2 d-flex align-items-center">
                <div class="check-wrapper" :class="{ checked: selectedAccountId === account.id }">
                  <!-- 用 SVG 模擬打勾符號 -->
                  <svg
                    v-if="selectedAccountId === account.id"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 16 16"
                    width="16"
                    height="16"
                    fill="#fff"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M13.854 3.146a.5.5 0 0 1 .0.708l-7.0 7.0a.5.5 0 0 1-.708 0l-3.0-3.0a.5.5 0 1 1 .708-.708l2.646 2.647 6.646-6.647a.5.5 0 0 1 .708 0z"
                    />
                  </svg>
                </div>
              </div>
              <!-- 第二欄：帳號名稱 + 頭像 (被勾選才顯示紫底) -->
              <div class="col-3 d-flex align-items-center">
                <div class="avatar me-2" :class="{ active: selectedAccountId === account.id }">
                  <!-- 若 nick_name 為 null，預設顯示 'C' -->
                  {{ account.nick_name || 'C' }}
                </div>
              </div>
              <div class="col-7">
                <div class="account-nickname">
                  {{ account.nick_name || 'Current account' }}
                </div>
                <div class="account-name mt-1">
                  <div class="account-detail">{{ account.account_name || 'No Name' }}</div>
                </div>
                <div class="account-text mt-1">
                  <div v-if="account.type === 1" class="account-detail">{{ account.bsb ? account.bsb + ' | ' : '' }}{{ account.account_number}}</div>
                  <div v-if="account.type === 2" class="account-detail">{{ account.phone }}</div>
                  <div v-if="account.type === 3" class="account-detail">{{ account.email }}</div>
                  <div v-if="account.type === 4" class="account-detail">Card ID: {{ account.EAID }}</div>
                </div>
                <!-- Auto pay 開關 - 只對卡片類型顯示 -->
                <div v-if="account.type === 4" class="auto-pay-section">
                  <div class="auto-pay-label">Auto pay</div>
                  <div class="auto-pay-toggle">
                    <label class="toggle-switch">
                      <input 
                        type="checkbox" 
                        :checked="account.auto_pay === 1" 
                        :disabled="account.auto_pay === 2"
                        @change="toggleAutoPay(account)"
                      >
                      <span class="toggle-slider"></span>
                    </label>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
    </div>

    <!-- 底部帳號部分 -->
    <div class="your-account-container">
        <div  class="frame-account pe-2 ps-2">
            <div class="account-title">Your account</div>
            <div>
                <img class="account-icon" src="@/assets/images/driver/account.png" />
            </div>
        </div>
        <div class="p-2">
            <div class="account-balance">Account balance</div>
            <div class="account-value">{{ formatCurrency(driverInfo.account_balance) }}</div>
            <div class="pending-text">Money in your account pending withdrawal</div>
            <div class="mt-1 d-flex align-items-center">
                <div class="payment-method">Payment method:</div>
                <div class="method-value">{{ driverInfo.payment_method }}</div>
            </div>
        </div>
    </div>

</template>


<script setup>
import { ref, computed, onMounted } from 'vue';
import { useDriverStore } from '@/store/driver/driver';
import Swal from 'sweetalert2'; // 引入 SweetAlert2


// 使用 Pinia store
const driverStore = useDriverStore();
// 用 computed 來讀取 driverInfo
const driverInfo = computed(() => driverStore.driverInfo);

// 新增狀態控制是否在編輯車牌或 ABN
const editingPlate = ref(false);
const editingAbn = ref(false);
const newPlateNumber = ref('');
const newAbn = ref('');

const selectedAccountId = ref(null); // 預設勾選第一筆，若不預設則設為 null

// Auto pay 開關處理
const toggleAutoPay = async (account) => {
  // 如果 auto_pay === 2，則不允許切換
  if (account.auto_pay === 2) {
    return;
  }
  
  try {
    // 先切換前端狀態
    const newAutoPayStatus = account.auto_pay === 1 ? 0 : 1;
    account.auto_pay = newAutoPayStatus;
    
    // 直接調用 driverStore 的方法
    await driverStore.updateAutoPay(account.id, newAutoPayStatus);
    
  } catch (error) {
    console.error('Error toggling auto pay:', error);
    // 如果 API 調用失敗，恢復原狀態
    account.auto_pay = account.auto_pay === 1 ? 0 : 1;
  }
};


const selectAccount = (id) => {
  selectedAccountId.value = id;
  driverStore.changeAccount(id);
};

const formatCurrency = (value) => {
    const absValue = Math.abs(value); // 取得絕對值並固定為兩位小數
    return value < 0 ? `-$${absValue}` : `$${absValue}`;
};

// 開始編輯車牌號碼
const startEditPlate = () => {
  editingPlate.value = true;
  newPlateNumber.value = driverInfo.value.plate_number;
};

// 開始編輯 ABN
const startEditAbn = () => {
  editingAbn.value = true;
  newAbn.value = driverInfo.value.abn;
};

// 取消編輯車牌號碼
const cancelEditPlate = () => {
  editingPlate.value = false;
  newPlateNumber.value = ''; // 清空輸入框
};

// 取消編輯 ABN
const cancelEditAbn = () => {
  editingAbn.value = false;
  newAbn.value = ''; // 清空輸入框
};

// 保存車牌號碼
const savePlateNumber = async () => {
  const result = await Swal.fire({
    title: 'Are you sure?',
    text: 'Do you want to update the plate number?',
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Yes, update it!',
    cancelButtonText: 'Cancel'
  });

  if (result.isConfirmed) {
    const updatedFields = {
      plate_number: newPlateNumber.value,
      abn: driverInfo.value.abn,
    };
    await driverStore.updateDriverInfo(updatedFields);
    editingPlate.value = false;
    Swal.fire('Updated!', 'The plate number has been updated.', 'success');
  }
};

// 保存 ABN 
const saveAbn = async () => {
  const result = await Swal.fire({
    title: 'Are you sure?',
    text: 'Do you want to update the ABN?',
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Yes, update it!',
    cancelButtonText: 'Cancel'
  });

  if (result.isConfirmed) {
    const updatedFields = {
      abn: newAbn.value,
      plate_number: driverInfo.value.plate_number,
    };
    await driverStore.updateDriverInfo(updatedFields);
    editingAbn.value = false;
    Swal.fire('Updated!', 'The ABN has been updated.', 'success');
  }
};

onMounted(async () => {
  await driverStore.fetchDriverInfo();

  const enabledAccount = driverInfo.value?.accounts?.find(acc => acc.enabled == 1);
  if (enabledAccount) {
    selectedAccountId.value = enabledAccount.id;
  } else {
    selectedAccountId.value = null;
  }
});
</script>


<style scoped>

/* 新增一些輸入框樣式 */
.form-input {
  border: 1px solid #ccc;
  padding: 2px;
  border-radius: 6px;
  font-size: 24px;
  width: 160px; /* 確保輸入框佔滿可用寬度 */
  margin-right: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 增加陰影效果 */
  transition: border-color 0.3s ease;
}

.form-input:focus {
  border-color: #5148da; /* 聚焦時邊框變色 */
}

.button-group {
  display: flex;
  gap: 10px; /* 按鈕之間的間距 */
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.btn-primary {
  background-color: #5148da;
  color: white;
  box-shadow: 0 2px 6px rgba(81, 72, 218, 0.3);
}

.btn-secondary {
  background-color: #ccc;
  color: black;
}

.btn-primary:hover {
  background-color: #392bb0;
}

.btn-secondary:hover {
  background-color: #a6a6a6;
}

.card {
    position: absolute;
    top: 80px;
    left: 0;
    right: 0;
    z-index: 1;
    height: 70%;
    width: 100%; /* 設置寬度為 100% */
    overflow-y: auto;
    overflow-x: hidden; /* 防止左右滑動 */
}

.card-body{
  margin-bottom: 100px;
}

.profile-title{
    width: 213px;
    height: 30px;
    left: 30px;

    /* Portal/Portal – H4 bold */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;

    /* 1E1E2D */
    color: #1E1E2D;


}

.your-info{
    margin-top: 10px;
    height: 25px;
    left: 30px;

    /* Portal/Portal – H5 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 25px;

    /* 1E1E2D */
    color: #1E1E2D;
}

.driver-name{
    width: 167px;
    height: 20px;

    /* Portal/Portal – H7 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
}

.name-value{
    margin-top: 5px;
    width: 167px;
    height: 28px;

    /* Portal/Portal – H4 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 30px;
    display: flex;
    align-items: center;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;

}

.driver-id{
    width: 155px;
    height: 20px;

    /* Portal/Portal – H7 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;

}

.terminal-number{
    width: 155px;
    height: 20px;

    /* Portal/Portal – H7 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
}

.id-value{

    width: 155px;
    height: 28px;

    /* Portal/Portal – H4 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 30px;
    display: flex;
    align-items: center;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;
}

.terminal-value{

    width: 155px;
    height: 28px;

    /* Portal/Portal – H4 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 30px;
    display: flex;
    align-items: center;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;

}

.edit-plate{
    height: 17px;

    /* Portal/Portal – H8 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    /* identical to box height, or 121% */
    display: flex;
    align-items: center;

    /* Indigo */
    color: #5248DA;
    cursor: pointer;

    mix-blend-mode: normal;

    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;
}

.edit-abn{
    height: 17px;

    /* Portal/Portal – H8 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    cursor: pointer;


    /* Indigo */
    color: #5248DA;

    mix-blend-mode: normal;

    /* Auto layout */
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;

    width: 155px;
    height: 16px;

    /* Inside auto layout */
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;

}

hr{
    margin-top: 15px;
    margin-bottom: 15px;
    border: 1px solid gray;
}


/* Your account section 固定在底部 */
.your-account-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 30vh; /* 佔據 20% 的視窗高度 */
  background-color: #f4f4f8;
  padding: 15px;
  z-index:1;
  border-radius: 20px 20px 0px 0px;
}

.account-title {

    /* Portal/Portal – H5 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 25px;
    display: flex;
    align-items: center;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;
}

.calendar-icon {
  width: 24px;
  height: 24px;
}

.account-balance {
    /* Account balance */

    /* Portal/Portal – H7 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;
}

.account-value{
    /* Portal/Portal – H2 bold */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 600;
    font-size: 36px;
    line-height: 46px;
    display: flex;
    align-items: center;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 1;
    align-self: stretch;
    flex-grow: 0;

}

.pending-text {

    /* Portal/Portal – body extra small */
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    /* identical to box height */

    /* Navy */
    color: #051C2C;

    opacity: 0.5;

    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 1;

}

.payment-method{
    width: 134px;
    height: 22px;

    /* Portal/Portal – body small */
    font-family: 'Mulish';
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 19px;

    /* Navy */
    color: #051C2C;


    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;
}

.method-value{
    /* Frame 291 */
    box-sizing: border-box;

    /* Auto layout */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 10px;
    gap: 10px;

    height: 32px;

    /* Green */
    border: 2px solid #00C962;
    border-radius: 6px;

    /* Inside auto layout */
    flex: none;
    order: 1;
    flex-grow: 0;


    /* Portal/Portal – H7 */
    font-family: 'Euclid Square';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    text-align: center;

    /* Navy */
    color: #051C2C;

}

.account-icon{
    margin: 0 auto;


    width: 48px;
    height: 48px;


    /* Inside auto layout */
    flex: none;
    order: 1;
    flex-grow: 0;

}

.frame-account{
    display: flex;
    justify-content: space-between; /* 讓內容居左右兩端 */
    width: auto; /* 確保寬度覆蓋整個父容器 */
}

.withdraw-title{
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 25px;
  display: flex;
  align-items: center;
  color: #051C2C;
}

.withdraw-subtitle{
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 19px;
  color: #051C2C;
}

/* 每個帳號區塊外觀 */
.account-item {
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 10px;
  cursor: pointer;
  transition: border 0.3s;
}

/* 被選取時外框顯示綠色 */
.account-item.selected {
  border-color: #00c962;
  border-width: 2px;
}

/* 勾選框外觀 */
.check-wrapper {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  background-color: #fff; /* 預設灰色底 */
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s;
  border: 1px solid #00c962;
}
.check-wrapper.checked {
  background-color: #00c962; /* 綠底勾選 */
}

/* 頭像底色，未勾選則為灰色，勾選後為紫色 */
.avatar {
  width: 52px;
  height: 52px;
  background-color: #9e9e9e; /* 預設灰色 */
  color: #fff;
  border-radius: 50%;
  display: flex;
  font-size: 24px;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s;
}
.avatar.active {
  background-color: #6f42c1; /* 紫色 */
}

.account-nickname{
  font-family: 'Euclid Square';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;

  color: #051C2C;
}

.account-text{
  font-family: 'Mulish';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: #051C2C;
}

/* Auto pay 開關樣式 */
.auto-pay-section {
  margin-top: 8px;
  display: flex;
  /* flex-direction: row; */
  align-items: baseline;
  gap: 8px;
  width: 100%;
  max-width: 120px;
}



.auto-pay-toggle {
  display: flex;
  align-items: center;
  
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 44px;
  
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  border: 2px solid #22313f;
  border-radius: 24px;
  transition: 0.2s;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 2px;
  bottom: 2px;
  background-color: #22313f;
  border-radius: 50%;
  transition: 0.2s;
}

.toggle-switch input:checked + .toggle-slider {
  border: 2px solid #00C962;
  background: #fff;
}

.toggle-switch input:checked + .toggle-slider:before {
  background-color: #00C962;
  left: 22px;
}

</style>

